
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { httpsImg } from '@/utils/tool'

@Component({
  name: 'Deatil'
})

export default class Tabs extends Vue {
  /**
   * @param {array} data 景区详情
   * @description: 默认空
   */
  @Prop({
    type: Object,
    default: () => ({})
  }) data!: any

  private httpsImg = httpsImg

  // 点击返回
  @Emit('back')
  clickBack () {
    return ''
  }
}
